import { useMemo } from 'react'
import { faCheck } from '@fortawesome/pro-light-svg-icons'
import { Box, Flex, Text, TextModifier } from '@pinchenterprisesnpm/friday-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { connect, FormikProps } from 'formik'
import { useSelector } from 'react-redux'
import { IShiftBadgesFormValues } from '@src/features/shift-post-v2/steps/screening-requirements-step/components/screening-section/screening-section.types'
import { selectSelectedShiftGigAutoAcceptCertificates } from '@src/data/SelectedShiftGigAutoAcceptCertificates/selectors'
import { selectSelectedShiftAutoAcceptCertificates } from '@src/data/AllBusinessAutoAcceptCertificates/selectors'
import { ShiftPostPage } from '@src/features/shift-post-v2/pages'

interface ISelectedBadgesListProps {
  formik?: FormikProps<IShiftBadgesFormValues>
  sourcePage?: ShiftPostPage
}

export const SelectedBadgesList = connect<ISelectedBadgesListProps>(({ formik, sourcePage }) => {
  const {
    values: { auto_accept_certificate_ids },
  } = formik

  // Use business certificates for post-shift, gig certificates for copy-shift
  const isPostShift = sourcePage === ShiftPostPage.POST_SHIFT

  const gigAutoAcceptCertificates = useSelector(selectSelectedShiftGigAutoAcceptCertificates)
  const businessAutoAcceptCertificates = useSelector(selectSelectedShiftAutoAcceptCertificates)

  // Choose the appropriate certificates based on the source page
  const shiftAutoAcceptCertificates = isPostShift
    ? businessAutoAcceptCertificates
    : gigAutoAcceptCertificates

  const selectedBadges = useMemo(() => {
    return shiftAutoAcceptCertificates.filter((certObj) =>
      auto_accept_certificate_ids.includes(certObj.certificate.id)
    )
  }, [shiftAutoAcceptCertificates, auto_accept_certificate_ids])

  if (selectedBadges.length === 0) {
    return (
      <Text my='sm' color='muted'>
        No screening requirements selected.
      </Text>
    )
  }

  return (
    <Box>
      {selectedBadges.map((certObj) => (
        <Flex key={certObj.certificate.id} mb='xs' alignItems='center'>
          <FontAwesomeIcon
            icon={faCheck}
            color='#43b94a'
            size='lg'
            style={{ marginRight: '8px' }}
          />
          <Text my='sm'>
            Only allow Upshifters with{' '}
            <TextModifier color='primary.500' fontWeight='semiBold'>
              {certObj.certificate.name}
            </TextModifier>{' '}
            certificate
          </Text>
        </Flex>
      ))}
    </Box>
  )
})
